import { render } from "./courses-index.vue?vue&type=template&id=3eb48e7a"
import script from "./courses-index.vue?vue&type=script&lang=js"
export * from "./courses-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__